import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import Banner from "../../components/general/Banner";
import Celikler from "../../components/general/Celikler";
import { fetchPageGetSlug } from "../../redux/slices/pageGetSlugSlice";
import { fetchSeoGet } from "../../redux/slices/seoGetSlice";

const About = () => {
  const page = useSelector((state) => state.pageGetSlug.data);
  const lang = useSelector((state) => state.lang.lang);
  const seo = useSelector((state) => state.seoGet.data);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true)
    await dispatch(fetchPageGetSlug({ slug: "hakkimizda" }));
    await dispatch(fetchSeoGet({ slug: "hakkimizda" }));
    setLoading(false)
  }

  console.log("seo:", seo)
  console.log("seo description:", seo?.description[lang])

  useEffect(() => {
    getData();
  }, []);

  const textColumnStyle = { lineHeight: "1.8" };

  return (
    !loading ? <Celikler>
      {seo && seo.title && seo.description && (
        <Helmet>
          <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
          <meta name="description" content={seo.description?.[lang] || ""} />
          <meta name="keywords" content={seo.keywords?.[lang] || ""} />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
      )}
      <Banner title={page?.title[lang]} />
      <div className="about-page">
        <div className="">
          <div className="about-text f24 d-flex align-items-center justify-content-center mt-5">
            <span className="color10 f32 fw500">{page?.showcases[0]?.title[lang]}</span>
          </div>
          <div className="about1 mt-5 mb-5 f17 fw500 color1">
            <Row>
              {
                (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
                  .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                  .map((item, index) => {
                    return (
                      <Col xs={12} sm={12} md={6} lg={6} xl={6} key={index} className="about-item mb-3" style={textColumnStyle}>
                        <span>{item?.description[lang]}</span>
                      </Col>
                    )
                  })
              }
            </Row>
          </div>
        </div>
      </div>
    </Celikler> : <div className="modern-spinner-wrapper">
      <div className="modern-spinner"></div>
    </div>
  );
};

export default About;
